/**
 * Simple wrapper that ensures that the provided function only runs when process.env.NODE_ENV is not set to `production` or `test`.
 * Meant to be used for performance optimizations.
 *
 * ```js
 * import { onlyRunInDev } from '@minerva-analytics/pantheon';
 * ```
 *
 * @param {Function} fn - The function that should only be called in development
 */
var onlyRunInDev = function onlyRunInDev(fn) {
  return function () {
    if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
      return fn.apply(void 0, arguments);
    } // Just to ensure that a falsey value is returned


    return null;
  };
};

export default onlyRunInDev;